import { render } from "./calendarOld.vue?vue&type=template&id=644a4644&scoped=true&ts=true"
import script from "./calendarOld.vue?vue&type=script&lang=ts"
export * from "./calendarOld.vue?vue&type=script&lang=ts"

import "./calendarOld.vue?vue&type=style&index=0&id=644a4644&scoped=true&lang=css"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644a4644"]])

export default __exports__